export default class Consts {
    static NotFound = '<Not found>';
}
